import React from 'react';
import { Navbar } from '../components/Navbar';
import { sha256 } from 'js-sha256'
import { Redirect, Link } from "react-router-dom";
import { ClompApi } from '../api/ClompApi';
import { GoogleSignInButton } from '../components/GoogleSignInButton';
import { GOOGLE_CLIENT_ID } from '../config';
import './Login.css';

const api = new ClompApi();

export class SignupPage extends React.Component {

    state = {
        email: "",
        username: "",
        password: "",
        confirmPassword: "",
        error: "",
        submitting: false,
        done: null
    };

    field = (name) => (e) => this.setState({ [name]: e.target.value });

    onRegister = async (event) => {
        event.preventDefault();
        let { email, username, password, confirmPassword } = this.state;

        if (!email || !username || !password || !confirmPassword) {
            this.setState({ error: "Fill in every field." });
            return;
        }
        if (!email.includes('@')) {
            this.setState({ error: "Enter a valid email address." });
            return;
        }
        if (password !== confirmPassword) {
            this.setState({ error: "Passwords do not match.", password: "", confirmPassword: "" });
            return;
        }

        this.setState({ submitting: true, error: "" });
        let hashed = sha256(password);
        try {
            await api.auth.register({ email, username, password: hashed });
        } catch (err) {
            console.log(err);
            // A plain Error carries the server's message; a raw axios error means no usable message came back
            let message = !err.isAxiosError ? err.message
                : err.response ? "Couldn't create the account. Please try again."
                : "Couldn't reach the server. Please try again.";
            this.setState({ error: message, submitting: false });
            return;
        }

        // Log the new account straight in; if that fails, send them to the login page
        try {
            let response = await api.auth.login(username, hashed);
            if (response.success === false) {
                throw new Error(response.message);
            }
            localStorage.setItem('token', response.token);
            this.setState({ done: "/home" });
        } catch (err) {
            console.log(err);
            this.setState({ done: "/login" });
        }
    }

    // Signing up with Google creates the account (or finds the existing one) and logs straight in
    onGoogleCredential = async (credential) => {
        this.setState({ submitting: true, error: "" });
        try {
            let response = await api.auth.googleLogin(credential);
            localStorage.setItem('token', response.token);
            this.setState({ done: "/home" });
        } catch (err) {
            console.log(err);
            let message = err.response && err.response.data && err.response.data.message;
            this.setState({ error: message || "Couldn't sign up with Google. Please try again.", submitting: false });
        }
    }

    render() {
        if (this.state.done) {
            return <Redirect to={this.state.done} />;
        }

        return (
            <>
                <Navbar history={this.props.history}></Navbar>
                <div className="login-page">
                    <div className="login-card">
                        <h1>Create an account</h1>
                        <p className="login-intro">Join clomp to save your scores and collect cards.</p>

                        <form className="login-form" onSubmit={this.onRegister} noValidate>
                            <label htmlFor="register-email">Email</label>
                            <input id="register-email" name="email" type="email" autoComplete="email" value={this.state.email} onChange={this.field('email')} />

                            <label htmlFor="register-username">Username</label>
                            <input id="register-username" name="username" type="text" autoComplete="username" value={this.state.username} onChange={this.field('username')} />

                            <label htmlFor="register-password">Password</label>
                            <input id="register-password" name="password" type="password" autoComplete="new-password" value={this.state.password} onChange={this.field('password')} />

                            <label htmlFor="register-confirm">Confirm password</label>
                            <input id="register-confirm" name="confirmPassword" type="password" autoComplete="new-password" value={this.state.confirmPassword} onChange={this.field('confirmPassword')} />

                            {this.state.error ? <p className="login-error" role="alert">{this.state.error}</p> : null}

                            <button type="submit" className="login-btn login-btn-primary" disabled={this.state.submitting}>
                                {this.state.submitting ? "Creating account..." : "Create account"}
                            </button>
                        </form>

                        {GOOGLE_CLIENT_ID ?
                            <>
                                <div className="login-divider"><span>or</span></div>
                                <GoogleSignInButton text="signup_with" onCredential={this.onGoogleCredential} onError={() => this.setState({ error: "Couldn't load Google sign-in." })} />
                            </>
                            : null}

                        <div className="login-divider"><span>Already have an account?</span></div>
                        <Link className="login-btn login-btn-ghost" to="/login">Log in</Link>
                    </div>

                    <Link className="login-guest" to="/">Continue as guest</Link>
                </div>
            </>
        );
    }
}
